import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Player } from '@lottiefiles/react-lottie-player';

const ErrorPage = () => {

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }, [])

    
    return (

        <main>
            <section className="error_page login_bg login_sec">
                <Player
                    autoplay
                    loop
                    className="img-fluid mx-auto mt-4 d-none d-md-block"
                    src="/assets/json_files/404.json"
                    style={{ maxWidth: '450px' }}
                >
                </Player>
                <br />
                <h5>
                    404 – PAGE NOT FOUND
                </h5>
                <p style={{ maxWidth: '550px', marginBottom: '30px' }} className="text-center mt-2" >The page you are looking for might have been removed, had its name changed or is temporarily unavailable.</p>
                <Link to="/" className="btn btn-warning custom-btn" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                    <i className="ri-home-2-line me-2"></i> Go To Home Page
                </Link>
            </section>
        </main>

    )
}

export default ErrorPage